export class GrauDeInstrucao{
    Valor: number|string = "";
    Descricao: string;

    constructor(){}
}